import React from 'react';
import CopyToClipboard from 'react-copy-to-clipboard';
import { FormattedMessage } from 'react-intl';

import { GlairIcon } from 'src/app/components/GlairIcon';
import { CSVDownload } from '../CSVDownload';
import { Button } from '../forms/Button';
import { WrappedColumn } from '../Table/WrappedColumn';
import { generate } from './TablePdfHelper';

interface TableReportToolbarProps {
  reportName: string;
  filename: string;
  columns: WrappedColumn[];
  rows: any[];
}

export class TableReportToolbar extends React.Component<TableReportToolbarProps> {
  render() {
    const { columns, rows, filename } = this.props;

    return (
      <>
        <CSVDownload data={this.toCsv(columns, rows)} filename={filename}>
          <Button figure="HeaderRegular" color="DetailNeutral">
            <GlairIcon icon="CSV" /> &nbsp; &nbsp;
            <FormattedMessage id="action.downloadCsv" />
          </Button>
        </CSVDownload>
        <CopyToClipboard text={this.toCsv(columns, rows)}>
          <Button figure="HeaderRegular" color="DetailNeutral">
            <GlairIcon icon="Copy" /> &nbsp; &nbsp;
            <FormattedMessage id="action.copyToClipboard" />
          </Button>
        </CopyToClipboard>
        <Button figure="HeaderRegular" color="Positive" onClick={this.generatePDF}>
          <GlairIcon icon="PDF" /> &nbsp; &nbsp;
          <FormattedMessage id="action.generatePdf" />
        </Button>
      </>
    );
  }

  private readonly generatePDF = (event: any) => {
    const { columns, rows, filename, reportName } = this.props;

    generate(columns, rows, filename, reportName);
  };

  private readonly toCsv = (columns: WrappedColumn[], data: any[]): string => {
    const headers: string[] = columns.map(col => col.name);
    const result: string[] = data.map((row: any) => {
      return row.join();
    });
    result.splice(0, 0, headers.join());
    return result.join('\n');
  };
}
